import { AppraisalReportApprovalStatus } from "src/models/estate/valuation-history.model";

export interface AppraisalDenialReasonDetails {
    appraisalDeniedReason: AppraisalDeniedReason,
    appraisalDeniedReasonDescription: string, 
    isUsedInPreappraisal: boolean
}

export interface ReportApprovalStatus {
    id: number;
    reportId: number;
    comment: string;
    signature: string;
    appraisalReportApprovalStatus: AppraisalReportApprovalStatus;
    appraisalDeniedReason: AppraisalDeniedReason;
    createdDate: Date;
}

export class ReportApprovalModel {
    constructor(
        public reportId: number,
        public appraisalReportApprovalStatus: AppraisalDialogApprovalStatus,
        public appraisalDeniedReason: AppraisalDeniedReason,
        public comment: string, 
        public signature: string) {}
}

export class CommercialReportApprovalModel {
    constructor(
        public refId: string, 
        public reportId: number,
        public approvalStatus: AppraisalDialogApprovalStatus, 
        public comment: string, 
        public signature: string) {}
}

export enum AppraisalDeniedReason {
    MissingPictures = 1,
    AssumedTooHighValue = 2,
    InspectionNotPerformed = 3,
    ChangedEstateType = 4,
    UsedForEarlyAppraisal = 5,
    InadequateDescription = 6,
    OutsideAgentsMarketArea = 7
}

export enum AppraisalDialogApprovalStatus {
    Ubehandlet = 1,
    Godkjent = 2,
    Avvist = 3
}